<div class="form-group">

    <label class="mgn-rigth-3 d-block">
        {{title}} {{control | controlRequiredText}}
    </label>

    <input-image-cropper #inputImageCropper [id]="id" [control]="control" [title]="title" [placeholder]="placeholder"
        [messageRequired]="messageRequired" [type]="type" (eventSelectFile)="eventSelectFile($event)">
    </input-image-cropper>

    <a *ngIf="modalName" role="button" class="font-size-14" (click)="onClickModalShow($event)">{{modalText}}</a>
</div>

<modal-image-cropper #modalImageCropper [id]="id" [type]="type"
    (eventUploadPhotoCropped)="eventUploadPhotoCropped($event)"
    (eventSelectAnotherFile)="eventSelectAnotherFile($event)"></modal-image-cropper>
